import { createFileRoute } from '@tanstack/react-router';
import ContractSignPage from '@/pages/contract-sign';

interface ContractSignSearch {
  preview: boolean;
}

export const Route = createFileRoute('/contract/$token')({
  validateSearch: (search: Record<string, unknown>): ContractSignSearch => ({
    preview:
      search.preview === '1' ||
      search.preview === 1 ||
      search.preview === true ||
      search.preview === 'true',
  }),
  component: ContractSignRoute,
});

function ContractSignRoute() {
  const { token } = Route.useParams();
  const { preview } = Route.useSearch();
  return <ContractSignPage token={token} preview={preview} />;
}
